/* eslint-disable no-console */
import TeamLayout from "../layouts/TeamLayout";
import TeamStreamLayout from "../layouts/TeamStreamLayout";

const subrouteName = name => {
	return `TEAM/${ name }`;
};

// eslint-disable-next-line no-unused-vars
export default ( {
	app,
	authService,
	layouts,
	loadedSlices,
} ) => {
	const lazyLoadTeamComponent = ( { component, } ) => {
		return () => {
			if ( !loadedSlices.has( "@teaming/slice-team" ) ) {
				return import( "@teaming/slice-team" ).then( async ( { teamSlice, } ) => {
					teamSlice();
					loadedSlices.set( "@teaming/slice-team", true );
					return app.component( component );
				} );
			}
			return Promise.resolve( app.component( component ) );
		};
	};

	return [
		{
			path: "/teams",
			name: "teams",
			meta: { title: "slice-team.routes.listing", },
			component: layouts.StandardAppLayout,
			props: true,
			children: [
				{
					path: "",
					name: "Team Listing",
					component: lazyLoadTeamComponent( { component: "TeamListingHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		},

		{
			path: "/team/:teamId/stream/:docType",
			name: subrouteName( "Stream" ),
			meta: { preventDefaultRouteTitle: true, }, // see DocumentMixin
			component: TeamStreamLayout,
			props: true,
			children: [
				{
					path: "",
					name: "Team Stream",
					component: lazyLoadTeamComponent( { component: "TeamStreamHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		},

		{
			path: "/team/:teamId/goal",
			name: "",
			meta: { preventDefaultRouteTitle: true, }, // see DocumentMixin
			component: layouts.RouterViewLayout,
			props: true,
			children: [
				{
					path: "new",
					name: subrouteName( "NEW_GOAL" ),
					meta: { bodyClass: "teaming-gokr--page", },
					component: lazyLoadTeamComponent( { component: "TeamNewGoalHOC", } ),
					props: true,
				},
				{
					path: ":goalId",
					name: subrouteName( "UPDATE_GOAL" ),
					meta: { bodyClass: "teaming-gokr--page", },
					component: lazyLoadTeamComponent( { component: "TeamGoalHOC", } ),
					props: true,
				},
				{
					path: ":goalId/key-result/new",
					name: subrouteName( "NEW_KEY_RESULT" ),
					meta: { bodyClass: "teaming-gokr--page", },
					component: lazyLoadTeamComponent( { component: "TeamNewKeyResultHOC", } ),
					props: true,
				},
				{
					path: ":goalId/key-result/:keyResultId",
					name: subrouteName( "UPDATE_KEY_RESULT" ),
					meta: { bodyClass: "teaming-gokr--page", },
					component: lazyLoadTeamComponent( { component: "TeamKeyResultHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		},

		{
			path: "/team/:teamId",
			name: "",
			meta: { preventDefaultRouteTitle: true, }, // see DocumentMixin
			component: TeamLayout,
			props: true,
			children: [
				{
					path: "",
					name: "Team",
					redirect: to => {
						const hasTrailingSlash = to.path.charAt( to.path.length - 1 ) === "/";
						const toPath = hasTrailingSlash ? to.path : `${ to.path }/`;
						return { path: `${ toPath }stream/shared`, };
					},
				},
				{
					path: "meetings",
					name: subrouteName( "TODAYS_MEETINGS" ),
					redirect: to => {
						const newPath = to.path.substring( 0, to.path.length - 8 ); // eslint-disable-line no-magic-numbers
						return { path: `${ newPath }stream/shared`, };
					},
				},
				{
					path: "meetings/:meetingDate",
					name: subrouteName( "MEETINGS" ),
					redirect: to => {
						const newPath = to.path.split( "/" ).slice( 0, 3 ).join( "/" ); // eslint-disable-line no-magic-numbers
						return { path: `${ newPath }/stream/shared`, };
					},
				},
				{
					path: "settings",
					name: subrouteName( "SETTINGS" ),
					component: lazyLoadTeamComponent( { component: "TeamSettingsHOC", } ),
					props: true,
				},
				{
					path: "workstyle",
					name: subrouteName( "WORK_STYLE" ),
					component: lazyLoadTeamComponent( { component: "TeamWorkstyleHOC", } ),
					props: true,
				},
				{
					path: "commitments",
					name: subrouteName( "ACTION_ITEMS" ),
					component: lazyLoadTeamComponent( { component: "TeamCommitmentsHOC", } ),
					props: true,
				},
				{
					path: "goals",
					name: subrouteName( "GOALS" ),
					component: lazyLoadTeamComponent( { component: "TeamGoalsHOC", } ),
					props: true,
				},
				{
					path: "health",
					name: subrouteName( "HEALTH" ),
					component: lazyLoadTeamComponent( { component: "TeamHealthHOC", } ),
					props: true,
				},
			],
			beforeEnter: authService.authGuard,
		},
	].filter( r => !!r );
};
